<template>
  <div class="legal-page">
    <header class="legal-header">
      <div class="header-container">
        <router-link to="/" class="logo-link">
          <img src="/landing/logo-white.svg" alt="Макетта" class="logo" />
        </router-link>
        <router-link to="/" class="back-link">← На главную</router-link>
      </div>
    </header>

    <main class="legal-content">
      <h1>Политика в отношении обработки персональных данных</h1>

      <section class="legal-section">
        <h2>1. Общие положения</h2>
        <p>Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. № 152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые Индивидуальным предпринимателем Немыкиной Екатериной Сергеевной (ИНН 421717178949, далее — Оператор).</p>
        <p>1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.</p>
        <p>1.2. Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта https://maketta.pro/</p>
      </section>

      <section class="legal-section">
        <h2>2. Основные понятия, используемые в Политике</h2>
        <p>2.1. Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств вычислительной техники.</p>
        <p>2.2. Блокирование персональных данных — временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных).</p>
        <p>2.3. Веб-сайт — совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу https://maketta.pro/</p>
        <p>2.4. Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств.</p>
        <p>2.5. Обработка персональных данных — любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), блокирование, удаление, уничтожение персональных данных.</p>
        <p>2.6. Оператор — государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и/или осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными.</p>
        <p>2.7. Персональные данные — любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю Веб-сайта.</p>
        <p>2.8. Персональные данные, разрешенные субъектом персональных данных для распространения, — персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных путем дачи согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения в порядке, предусмотренном Законом о персональных данных.</p>
        <p>2.9. Пользователь — любой посетитель веб-сайта https://maketta.pro/</p>
        <p>2.10. Предоставление персональных данных — действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц.</p>
        <p>2.11. Распространение персональных данных — любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом.</p>
        <p>2.12. Трансграничная передача персональных данных — передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу.</p>
        <p>2.13. Уничтожение персональных данных — любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и/или уничтожаются материальные носители персональных данных.</p>
      </section>

      <section class="legal-section">
        <h2>3. Основные права и обязанности Оператора</h2>
        <p>3.1. Оператор имеет право:</p>
        <ul>
          <li>получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные;</li>
          <li>в случае отзыва субъектом персональных данных согласия на обработку персональных данных, а также, направления обращения с требованием о прекращении обработки персональных данных, Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Законе о персональных данных;</li>
          <li>самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Законом о персональных данных или другими федеральными законами.</li>
        </ul>
        <p>3.2. Оператор обязан:</p>
        <ul>
          <li>предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его персональных данных;</li>
          <li>организовывать обработку персональных данных в порядке, установленном действующим законодательством РФ;</li>
          <li>отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Закона о персональных данных;</li>
          <li>сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу этого органа необходимую информацию в течение 10 дней с даты получения такого запроса;</li>
          <li>публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике в отношении обработки персональных данных;</li>
          <li>принимать правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных;</li>
          <li>прекратить передачу (распространение, предоставление, доступ) персональных данных, прекратить обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных данных;</li>
          <li>исполнять иные обязанности, предусмотренные Законом о персональных данных.</li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>4. Основные права и обязанности субъектов персональных данных</h2>
        <p>4.1. Субъекты персональных данных имеют право:</p>
        <ul>
          <li>получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Законом о персональных данных;</li>
          <li>требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав;</li>
          <li>выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг;</li>
          <li>на отзыв согласия на обработку персональных данных, а также, на направление требования о прекращении обработки персональных данных;</li>
          <li>обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных;</li>
          <li>на осуществление иных прав, предусмотренных законодательством РФ.</li>
        </ul>
        <p>4.2. Субъекты персональных данных обязаны:</p>
        <ul>
          <li>предоставлять Оператору достоверные данные о себе;</li>
          <li>сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.</li>
        </ul>
        <p>4.3. Лица, передавшие Оператору недостоверные сведения о себе, либо сведения о другом субъекте персональных данных без согласия последнего, несут ответственность в соответствии с законодательством РФ.</p>
      </section>

      <section class="legal-section">
        <h2>5. Принципы обработки персональных данных</h2>
        <p>5.1. Обработка персональных данных осуществляется на законной и справедливой основе.</p>
        <p>5.2. Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.</p>
        <p>5.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой.</p>
        <p>5.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки.</p>
        <p>5.5. Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки. Не допускается избыточность обрабатываемых персональных данных по отношению к заявленным целям их обработки.</p>
        <p>5.6. При обработке персональных данных обеспечивается точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных. Оператор принимает необходимые меры и/или обеспечивает их принятие по удалению или уточнению неполных или неточных данных.</p>
        <p>5.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные уничтожаются либо обезличиваются по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено федеральным законом.</p>
      </section>

      <section class="legal-section">
        <h2>6. Цели обработки персональных данных</h2>

        <div class="purpose-table">
          <div class="purpose-block">
            <div class="purpose-row">
              <span class="purpose-label">Цель обработки</span>
              <span class="purpose-value">заключение, исполнение и прекращение гражданско-правовых договоров (приобретение Пользователем услуг Оператора)</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Персональные данные</span>
              <span class="purpose-value">
                <ul>
                  <li>фамилия, имя, отчество (в объеме, указанном Пользователем)</li>
                  <li>номер телефона;</li>
                  <li>адрес электронной почты</li>
                  <li>пол</li>
                </ul>
              </span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Правовые основания</span>
              <span class="purpose-value">
                <ul>
                  <li>Гражданский кодекс РФ;</li>
                  <li>Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и защите информации»;</li>
                  <li>Иные нормативные акты, регулирующие отношения, связанные с деятельностью Оператора, и нормативные документы уполномоченных государственных органов РФ;</li>
                  <li>договор заключаемый между Пользователем и Оператором (путем акцепта Пользователем оферты Оператора)</li>
                  <li>согласия субъектов персональных данных на обработку их персональных данных</li>
                </ul>
              </span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Виды обработки персональных данных</span>
              <span class="purpose-value">
                <ul>
                  <li>сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача, блокирование, удаление, уничтожение персональных данных</li>
                </ul>
              </span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Категории Пользователей</span>
              <span class="purpose-value">физические лица, заключившие или имеющие намерение заключить с Оператором гражданско-правовой договор приобретения услуг, представленных на Веб-сайте.</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Способы обработки</span>
              <span class="purpose-value">смешанная обработка персональных данных (неавтоматизированная и с использованием средств автоматизации, с передачей полученной информации по сети или без таковой).</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Сроки обработки и хранения</span>
              <span class="purpose-value">с даты предоставления персональных данных Пользователями с их согласия (в применимых случаях) и в течение 3 лет с даты исполнения Сторонами обязательств по заключенному договору (при условии его заключения, с учетом срока исковой давности по требованиям об исполнении договоров), или до достижения цели обработки персональных данных, или до момента отзыва Пользователем своего согласия на обработку персональных данных/получения Оператором требования о прекращении обработки персональных данных, если иной срок не предусмотрен договором или действующим законодательством.</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Хранение персональных данных</span>
              <span class="purpose-value">на материальных носителях в специальных местах, исключающих несанкционированный доступ. На электронных носителях – с использованием программных средств ограничения доступа к данным.</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Достижение целей обработки</span>
              <span class="purpose-value">При достижении целей обработки персональных данных или наступления иных оснований прекращения обработки персональных данных материальные носители персональных данных уничтожаются, с электронных носителей персональные данные удаляются без возможности их восстановления.</span>
            </div>
          </div>

          <div class="purpose-block">
            <div class="purpose-row">
              <span class="purpose-label">Цель обработки</span>
              <span class="purpose-value">сбор статистической информации о действиях Пользователя на Веб-сайте, улучшение качества Веб-сайта и его содержания с помощью сервисов интернет-статистики (аналитики) Яндекс-Метрика, Яндекс Вебмастер</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Персональные данные</span>
              <span class="purpose-value">
                <ul>
                  <li>cookie-файлы (действия Пользователя на Веб-сайте)</li>
                </ul>
              </span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Правовые основания</span>
              <span class="purpose-value">
                <ul>
                  <li>Гражданский кодекс РФ;</li>
                  <li>Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и защите информации»;</li>
                  <li>Иные нормативные акты, регулирующие отношения, связанные с деятельностью Оператора, и нормативные документы уполномоченных государственных органов РФ;</li>
                  <li>Согласия субъектов персональных данных на обработку их персональных данных</li>
                </ul>
              </span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Виды обработки персональных данных</span>
              <span class="purpose-value">
                <ul>
                  <li>Сбор, запись, систематизация, накопление, хранение, уничтожение персональных данных, передача Персональных данных с согласия Пользователя</li>
                </ul>
              </span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Категории Пользователей</span>
              <span class="purpose-value">посетители Веб-сайта</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Способы обработки</span>
              <span class="purpose-value">с использованием средств автоматизации, с передачей полученной информации по сети или без таковой</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Сроки обработки и хранения</span>
              <span class="purpose-value">с даты предоставления персональных данных Пользователями с их согласия (в применимых случаях) до достижения цели обработки персональных данных или до момента отзыва Пользователем своего согласия на обработку персональных данных/получения Оператором требования о прекращении обработки персональных данных, если иной срок не предусмотрен договором или действующим законодательством.</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Хранение персональных данных</span>
              <span class="purpose-value">На электронных носителях – с использованием программных средств ограничения доступа к данным.</span>
            </div>
            <div class="purpose-row">
              <span class="purpose-label">Достижение целей обработки</span>
              <span class="purpose-value">При достижении целей обработки персональных данных или наступления иных оснований прекращения обработки персональных данных материальные носители персональных данных уничтожаются, с электронных носителей персональные данные удаляются без возможности их восстановления.</span>
            </div>
          </div>
        </div>
      </section>

      <section class="legal-section">
        <h2>7. Условия обработки персональных данных</h2>
        <p>7.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных.</p>
        <p>7.2. Обработка персональных данных необходима для достижения целей, предусмотренных международным договором Российской Федерации или законом, для осуществления возложенных законодательством Российской Федерации на оператора функций, полномочий и обязанностей.</p>
        <p>7.3. Обработка персональных данных необходима для осуществления правосудия, исполнения судебного акта, акта другого органа или должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об исполнительном производстве.</p>
        <p>7.4. Обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем.</p>
        <p>7.5. Обработка персональных данных необходима для осуществления прав и законных интересов оператора или третьих лиц либо для достижения общественно значимых целей при условии, что при этом не нарушаются права и свободы субъекта персональных данных.</p>
        <p>7.6. Осуществляется обработка персональных данных, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных либо по его просьбе (далее — общедоступные персональные данные).</p>
        <p>7.7. Осуществляется обработка персональных данных, подлежащих опубликованию или обязательному раскрытию в соответствии с федеральным законом.</p>
      </section>

      <section class="legal-section">
        <h2>8. Порядок сбора, хранения, передачи и других видов обработки персональных данных</h2>
        <p>8.1. Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства в области защиты персональных данных. Описание мер, предусмотренных статьями 18.1 и 19 Федерального закона «О персональных данных»: для обеспечения безопасности персональных данных принимаются следующие меры: правовые, организационные и технические меры по обеспечению безопасности персональных данных. Изучение положений законодательства РФ о персональных данных, в том числе, требований к защите персональных данных. Доступ третьих лиц к персональным данным ограничен. Определены места хранения персональных данных и средства их защиты. Средства обеспечения безопасности персональных данных: хранение в сейфах, пароли, программные средства защиты информации (антивирусы).</p>
        <p>8.2. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.</p>
        <p>8.3. Персональные данные Пользователя не передаются третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства либо в случае, если субъектом персональных данных дано согласие Оператору на передачу данных третьему лицу.</p>
        <p>8.4. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления Оператору уведомление на адрес электронной почты Оператора maketta.pro@mail.ru с пометкой «Актуализация персональных данных».</p>
        <p>8.5. Срок обработки персональных данных определяется достижением целей, для которых были собраны персональные данные, если иной срок не предусмотрен договором или действующим законодательством. Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора maketta.pro@mail.ru с пометкой «Отзыв согласия на обработку персональных данных».</p>
      </section>

      <section class="legal-section">
        <h2>9. Перечень действий, производимых Оператором с полученными персональными данными</h2>
        <p>9.1. Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), распространение, блокирование, удаление и уничтожение персональных данных.</p>
        <p>9.2. Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей полученной информации по информационно-телекоммуникационным сетям или без таковой.</p>
      </section>

      <section class="legal-section">
        <h2>10. Трансграничная передача персональных данных</h2>
        <p>Оператор не осуществляет трансграничную передачу персональных данных.</p>
      </section>

      <section class="legal-section">
        <h2>11. Конфиденциальность персональных данных</h2>
        <p>Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом.</p>
      </section>

      <section class="legal-section">
        <h2>12. Заключительные положения</h2>
        <p>12.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты maketta.pro@mail.ru</p>
        <p>12.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика действует бессрочно до замены ее новой версией.</p>
        <p>12.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу https://maketta.pro/</p>
        <div class="requisites">
          <p><strong>Данные Оператора:</strong></p>
          <p>ИП Немыкина Екатерина Сергеевна</p>
          <p>ИНН 421717178949</p>
          <p>maketta.pro@mail.ru</p>
        </div>
      </section>
    </main>

    <footer class="legal-footer">
      <p>© 2025 — {{ currentYear }} Макетта. Все права защищены.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return { currentYear: new Date().getFullYear() }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.legal-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 20px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 36px;
  width: 99px;
  object-fit: contain;
}

.back-link {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.back-link:hover {
  opacity: 1;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

h1 {
  font-size: 32px;
  color: #1a1a2e;
  margin-bottom: 30px;
}

.legal-section {
  margin-bottom: 30px;
}

.legal-section h2 {
  font-size: 20px;
  color: #1a1a2e;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.legal-section p {
  color: #444;
  line-height: 1.7;
  margin-bottom: 10px;
}

.legal-section ul {
  margin: 8px 0 8px 20px;
  color: #444;
  line-height: 1.7;
}

.legal-section li {
  margin-bottom: 5px;
}

.purpose-table {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 15px;
}

.purpose-block {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}

.purpose-row {
  display: flex;
  border-bottom: 1px solid #eee;
}

.purpose-row:last-child {
  border-bottom: none;
}

.purpose-label {
  width: 220px;
  flex-shrink: 0;
  background: #f8f9fa;
  padding: 12px 15px;
  font-weight: 600;
  font-size: 13px;
  color: #555;
  border-right: 1px solid #eee;
}

.purpose-value {
  padding: 12px 15px;
  color: #444;
  font-size: 14px;
  line-height: 1.6;
  flex: 1;
}

.purpose-value ul {
  margin: 0;
  padding-left: 18px;
}

.purpose-value li {
  margin-bottom: 4px;
}

.requisites {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-top: 15px;
}

.requisites p {
  margin-bottom: 5px;
}

.legal-footer {
  text-align: center;
  padding: 30px;
  color: #666;
}

@media (max-width: 768px) {
  h1 {
    font-size: 24px;
  }

  .legal-content {
    padding: 20px 15px;
  }

  .purpose-row {
    flex-direction: column;
  }

  .purpose-label {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #eee;
  }
}
</style>
